import { render, staticRenderFns } from "./employees-list.vue?vue&type=template&id=5ca74a7f&"
import script from "./employees-list.vue?vue&type=script&lang=js&"
export * from "./employees-list.vue?vue&type=script&lang=js&"
import style0 from "./employees-list.vue?vue&type=style&index=0&id=5ca74a7f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports